import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'cnrm',
})
export class CnrmPipe implements PipeTransform {
  transform(value: string): string {
    if (value?.length < 5 || value?.length > 11) {
      return value
    }
    return value && value.replace(/^(\d{4})(\d*)$/, '$1-$2')
  }
}
